import { HierarchyLevels, PackageType } from '@retail/products/types';

export enum PriceType {
  GTIN = 'GTIN',
  NET = 'NET',
  REBATE = 'REBATE',
}

export enum PriceUnit {
  STK = 'ST',
  BNT = 'BNT',
  PKT = 'PKT',
  PAL = 'PAL',
  RLE = 'RLE',
  FRP = 'FRP',
  BRK = 'BRK',
}

export interface ItemAgreementDTO {
  agreementId: number;
  agreementNumber: number;
  agreementText: string;
  price: number;
  priceUnit: string;
  packagePrice: number;
  packagePriceUnit: string;
  priceType: PriceType;
  packageType: PackageType;
  isActive: boolean;
  bindingType?: HierarchyLevels;
}
